import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface MasterConcepts {
  name: string
  code: string
  countryId: string
  conceptFormatId: string
  conceptCategoryId: string
  conceptTypeId: string
  appliesTo: any[]
  isStandard: boolean
}

export async function getMasterConcepts(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = [
    'master_concepts.country_id = :countryId',
    'master_concepts.concept_type_id = concept_types.id',
    'master_concepts.concept_format_id = concept_formats.id',
    'master_concepts.concept_category_id=concept_categories.id'
  ]
  if (search) {
    where.push(
      `CONCAT(master_concepts.name,master_concepts.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          'GROUP BY master_concepts.id, concept_types.name, concept_formats.name, concept_categories.name',
          `ORDER BY (CASE WHEN master_concepts.code ~ '^[0-9]+$' THEN CAST(master_concepts.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, master_concepts.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        'GROUP BY master_concepts.id, concept_types.name, concept_formats.name, concept_categories.name',
        "ORDER BY (CASE WHEN master_concepts.code ~ '^[0-9]+$' THEN CAST(master_concepts.code AS numeric) ELSE NULL END), master_concepts.code"
      ])
  // result
  const response: any = await getData({
    tables: [
      'pg_master_concepts, concept_types, concept_formats, concept_categories'
    ],
    fields: [
      'master_concepts.id',
      'master_concepts.code',
      'master_concepts.name',
      'master_concepts.is_inactive',
      'concept_formats.name as format',
      'concept_categories.name as category',
      'concept_types.name as type',
      'master_concepts.updated_at'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getMasterConcept(id: string): Promise<MasterConcepts> {
  const data = await getData<any>({
    tables: ['pg_master_concepts'],
    fields: [
      'id',
      'code',
      'name',
      'country_id as countryId',
      'concept_category_id as conceptCategoryId',
      'concept_type_id as conceptTypeId',
      'concept_format_id as conceptFormatId',
      'is_inactive',
      'applies_to as appliesTo',
      'is_standard as isStandard',
      'custom_fields as custom'
    ],
    where: [`master_concepts.id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createMasterConcept(
  data: MasterConcepts
): Promise<boolean> {
  const response: any = await http.post('concept/master-concepts', {
    name: data.name,
    code: data.code,
    countryId: data.countryId,
    conceptFormatId: data.conceptFormatId,
    conceptCategoryId: data.conceptCategoryId,
    conceptTypeId: data.conceptTypeId,
    appliesTo: data.appliesTo,
    isStandard: data.isStandard,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateMasterConcept(
  data: MasterConcepts,
  id: string
): Promise<boolean> {
  const response: any = await http.put('concept/master-concepts/' + id, {
    name: data.name,
    code: data.code,
    countryId: data.countryId,
    conceptFormatId: data.conceptFormatId,
    conceptCategoryId: data.conceptCategoryId,
    conceptTypeId: data.conceptTypeId,
    appliesTo: data.appliesTo,
    isStandard: data.isStandard,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateConceptsMaster(
  id: string,
  state: boolean
): Promise<boolean> {
  const response: any = await http.put(`concept/master-concepts/${id}/enable`, {
    enable: state
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteMasterConcept(id: string): Promise<boolean> {
  const response: any = await http.delete('concept/master-concepts/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
